export default "__VITE_ASSET__Cck1H8DT__"